export default "/_next/static/images/section-4-81ec37f2a6ffa8f9de6d145e4465d15c.png";